"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPrintAndPromo = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconPrintAndPromo = function IconPrintAndPromo(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20,0 C22.209139,0 24,1.790861 24,4 L24,20 C24,22.209139 22.209139,24 20,24 L4,24 C1.790861,24 0,22.209139 0,20 L0,4 C0,1.790861 1.790861,0 4,0 L20,0 Z M13.5226481,4 L6,4 L6,20 L10.097561,20 L10.097561,14.6949602 L13.5226481,14.6949602 C15.2926829,14.6949602 16.6480836,14.2281167 17.5888502,13.2944297 C18.5296167,12.3607427 19,11.0450928 19,9.34748011 C19,7.64986737 18.5296167,6.33421751 17.5888502,5.4005305 C16.6480836,4.4668435 15.2926829,4 13.5226481,4 Z M12.5028902,7 C14.1676301,7 15,7.66666667 15,9 C15,10.3333333 14.1676301,11 12.5028902,11 L10,11 L10,7 L12.5028902,7 Z",
    fillRule: "evenodd"
  }));
};
exports.IconPrintAndPromo = IconPrintAndPromo;